import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsAccessRoute: InvariantJiraRoute = {
	name: 'global-settings-products-access',
	path: '/secure/admin/ApplicationAccess.jspa',
};
